import { render } from "./tareaMain.vue?vue&type=template&id=5b628bde"
import script from "./tareaMain.vue?vue&type=script&lang=js"
export * from "./tareaMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__